import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useObjectRef } from 'react-aria';
import { useIsElementScrolled } from '../../hooks/useIsScrolled.js';
import { twMerge } from '../../utils/twMerge.js';
export const DialogBody = forwardRef(function DialogBody(props, forwardedRef) {
    const ref = useObjectRef(forwardedRef);
    const { onScroll, isScrolledDown } = useIsElementScrolled(ref);
    return (_jsx("div", { ...props, ref: ref, onScroll: onScroll, className: twMerge('ppl-DialogBody overflow-auto px-5 pb-6', isScrolledDown && 'shadow-inner', props.className) }));
});
//# sourceMappingURL=DialogBody.js.map